import * as type from '../../constants';

const initialState = {
    updateLoder: null,
    loadingActivityList: false,
    activityList: null,

    loading: false,
    activityDetails: null,
    interestredUserList: null,

    loadingActiveGuestList: false,
    activeGuestList: {
      data: []
    },

    updateLoading: false,
    
    error: null
}

export function groupClassesAndActivityReducer(state = initialState, action) {
  switch (action.type) {

    case type.GET_ACTIVITY_LIST_BY_DATE:
    return {
        ...state,
        loadingActivityList: true,
        activityList: null,
    }
    case type.GET_ACTIVITY_LIST_BY_DATE_SUCCESS:
    return {
        ...state,
        loadingActivityList: false,
        activityList: action.payload,
        error: null
    }
    case type.GET_ACTIVITY_LIST_BY_DATE_FALIURE:
    return {
        ...state,
        loadingActivityList: false,
        activityList: null
    }

    case type.GET_ACTIVITY_DETAILS:
        return {
            ...state,
            loading: true,
        }
    case type.GET_ACTIVITY_DETAILS_SUCCESS:
    return {
        ...state,
        loading: false,
        activityDetails: action.payload,
        error: null
    }
    case type.GET_ACTIVITY_DETAILS_FALIURE:
    return {
        ...state,
        loading: false,
        activityDetails: null
    }
    case type.CLEAR_ACTIVITY_DETAILS:
        return {
            ...state,
            activityDetails: null
        }

    case type.GET_INTERESTED_USER_LIST:
        return {
            ...state,
            loading: true,
        }
    case type.GET_INTERESTED_USER_LIST_SUCCESS:
    return {
        ...state,
        loading: false,
        interestredUserList: action.payload,
        error: null
    }
    case type.GET_INTERESTED_USER_LIST_FALIURE:
    return {
        ...state,
        loading: false,
        interestredUserList: null
    }


    case type.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY:
        return {
            ...state,
            loadingActiveGuestList: true,
        }
    case type.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_SUCCESS:
      // if(action.payload?.current_page_no === 1)
        return {
        ...state,
        loadingActiveGuestList: false,
        activeGuestList: action.payload,
        error: null
      }
      // return {
      //     ...state,
      //     loadingActiveGuestList: false,
      //     activeGuestList: {
      //       ...state.activeGuestList,
      //       data: [...(state.activeGuestList?.data || []), ...(action.payload?.data || [])],
      //       current_page_no: action.payload?.current_page_no,
      //     },
      //     error: null
      // }
    case type.GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_FALIURE:
        return {
            ...state,
            loadingActiveGuestList: false,
            activeGuestList: {
              data: []
            }
        }

    case type.ADD_USER_TO_GROUP_ACTIVITY:
        return {
            ...state,
            updateLoading: true,
        }
    case type.ADD_USER_TO_GROUP_ACTIVITY_SUCCESS:
        return {
            ...state,
            updateLoading: false,
            activeGuestList:{
              ...state.activeGuestList,
              data: state.activeGuestList?.data.filter(
                user => !action.payload.userIds.includes(user.user_program_id)
              )
            }
        }
    case type.ADD_USER_TO_GROUP_ACTIVITY_FALIURE:
        return {
            ...state,
            updateLoading: false,
        }


    case type.REMOVE_USER_FROM_GROUP_ACTIVITY:
        return {
            ...state,
            updateLoading: true,
        }
    case type.REMOVE_USER_FROM_GROUP_ACTIVITY_SUCCESS:
        return {
            ...state,
            updateLoading: false,
            interestredUserList: state.interestredUserList?.filter(item=> item.user_id!== action.payload.userId)
        }
    case type.REMOVE_USER_FROM_GROUP_ACTIVITY_FALIURE:
        return {
            ...state,
            updateLoading: false,
        }

            
    default:
      return state
  }
}

